import { render } from "./SidebarContents.vue?vue&type=template&id=12009790&scoped=true"
import script from "./SidebarContents.vue?vue&type=script&lang=js"
export * from "./SidebarContents.vue?vue&type=script&lang=js"

import "./SidebarContents.vue?vue&type=style&index=0&id=12009790&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12009790"]])

export default __exports__